























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UpdateExpTableModal extends Vue {
     createnew: any;

    // Props
    @Prop({ default() { return {}; } })
    item!: any;

    @Prop({ default() { return null; } })
    servicesFilter!: any;

    // Data
    dialog = false;
    loading = false;
    // form = {
    //     level: this.item.level,
    //     exp_required: this.item.exp_required
    // };
    form = {
        name: this.item.name,
        description: this.item.description,
        exp_amount: this.item.exp_amount,
        hook_service: this.item.hook_service,
        hook_method: /*this.item.hook_method*/'create',
        esb_hook: this.item.esb_hook
    };

    // Methods
    public async SubmitUpdate() {
        try {
            this.loading = true;
            this.item.name = this.form.name;
            this.item.description = this.form.description;
            this.item.exp_amount = this.form.exp_amount;
            this.item.hook_service = this.form.hook_service;
            // this.item.hook_method = this.form.hook_method;
            this.item.esb_hook = this.form.esb_hook;
            await this.item.patch();
            this.$emit('success');
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
